import tw, { styled } from 'twin.macro';

import { Title } from '@/components/LogoBlock/LogoBlock.styles';
import LogoBlock from '@/components/LogoBlock/LogoBlock';

export const StyledLogoBlock = styled(LogoBlock)<{ hasSideContent: boolean }>`
  ${tw`col-span-12`}
  ${tw`my-[4px]`}
  ${tw`py-0!`}
  ${Title} {
    ${tw`mb-2`}
    ${({ hasSideContent }) => (hasSideContent ? tw`text-left` : tw`text-center`)}
  }
`;
